import PropTypes from 'prop-types';
import React from 'react';
import Radium from 'radium';

import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Collapse from 'react-bootstrap/lib/Collapse';

import _ from '@ihme/common/locale';
import locale from './locale';

const propTypes = {
    itemKey: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    iconSrc: PropTypes.string.isRequired,
};

const defaultProps = {};

class HighlightItem extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.onToggle = this.onToggle.bind(this);
    }

    onToggle() {
        this.setState(prevState => ({ open: !prevState.open }));
    }

    render() {
        const { itemKey, description, text, title, iconSrc } = this.props;
        const { open } = this.state;
        const panelId = `highlight-panel-${itemKey}`;
        const headingId = `highlight-heading-${itemKey}`;

        return (
            <Row>
                <Col sm={3}>
                    <button
                        type="button"
                        className="highlight-image-button"
                        style={styles.imageButton}
                        onClick={this.onToggle}
                        aria-expanded={open}
                        aria-controls={panelId}
                        aria-labelledby={headingId}
                    >
                        <img style={styles.image} src={iconSrc} alt="" />
                    </button>
                </Col>
                <Col sm={9}>
                    <article style={styles.article}>
                        <h3 id={headingId} className="home-highlight__title">
                            {title}
                        </h3>
                        <div style={styles.container}>
                            <p
                                style={styles.paragraph}
                                dangerouslySetInnerHTML={{ __html: description }}
                            />
                            {!open && (
                                <button
                                    type="button"
                                    className="highlight-read-toggle"
                                    onClick={this.onToggle}
                                    aria-expanded={open}
                                    aria-controls={panelId}
                                >
                                    {_(locale.more)}
                                </button>
                            )}

                            <div
                                id={panelId}
                                role="region"
                                aria-labelledby={headingId}
                                aria-hidden={!open}
                            >
                                <Collapse in={open}>
                                    <div>
                                        <div dangerouslySetInnerHTML={{ __html: text }} />
                                        {open && (
                                            <button
                                                type="button"
                                                className="highlight-read-toggle"
                                                onClick={this.onToggle}
                                                aria-expanded={open}
                                                aria-controls={panelId}
                                            >
                                                {_(locale.less)}
                                            </button>
                                        )}
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                    </article>
                </Col>
            </Row>
        );
    }
}

const styles = {
    container: {
        backgroundColor: 'white',
        marginBottom: 20,
        minHeight: 134,
    },
    imageButton: {
        width: '100%',
    },
    icon: {
        float: 'left',
        margin: '0pt 10pt 0pt 0pt',
        width: 120,
    },
    title: {
        marginTop: 2,
        marginBottom: 6,
    },
    paragraph: {
        marginBottom: 10,
    },
    image: {
        width: '100%',
        borderRadius: 4,
        backgroundColor: '#f5f7f8',
        display: 'block',
        ':hover': {
            opacity: 0.8,
        },
    },
    article: {
        marginBottom: 30,
    },
};

HighlightItem.propTypes = propTypes;
HighlightItem.defaultProps = defaultProps;

export default Radium(HighlightItem);
